import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getLogs } from '../../services/pension'

const initialState = {
  logsByContext: {},        // { scraperMain: [...], senderMain: [...] }
  loadingByContext: {},     // { scraperMain: true/false, senderMain: true/false }
  errorByContext: {},       // { scraperMain: errorObj, senderMain: errorObj }
  status: 'idle'
}

/**
 * Gets logs for a specific context
 */
export const onGetLogsAsync = createAsyncThunk('adminPensionLogs/getLogs', async ({ context }) => {
  const data = await getLogs({ context })
  return { context, data }
})

const pensionLogsSlice = createSlice({
  name: 'adminPensionLogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(onGetLogsAsync.pending, (state, action) => {
        const context = action.meta.arg.context
        state.loadingByContext[context] = true
        state.errorByContext[context] = null
      })
      .addCase(onGetLogsAsync.fulfilled, (state, action) => {
        const { context, data } = action.payload
        state.loadingByContext[context] = false
        state.logsByContext[context] = data
      })
      .addCase(onGetLogsAsync.rejected, (state, action) => {
        const context = action.meta.arg.context
        state.loadingByContext[context] = false
        state.errorByContext[context] = action.error
      })
  }
})

export default pensionLogsSlice.reducer
